import { render, staticRenderFns } from "./createCustomer.vue?vue&type=template&id=5a69bb5e&scoped=true&"
import script from "./createCustomer.vue?vue&type=script&lang=js&"
export * from "./createCustomer.vue?vue&type=script&lang=js&"
import style0 from "./createCustomer.vue?vue&type=style&index=0&id=5a69bb5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a69bb5e",
  null
  
)

export default component.exports